import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import withRouter from '../.././components/withRouter';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import logoLight from '../../assets/images/logo-light.png';
import ParticlesAuth from './ParticlesAuth';
import { postForgetPwd } from '../../api/authApi';
import { toast } from 'react-toastify';

const ForgetPasswordPage = (props: any) => {
    const navigate = useNavigate();
    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('E-mail inválido').required('Por favor, insira seu e-mail'),
        }),
        onSubmit: (values) => {
            postForgetPwd(values.email).then(() => {
                validation.resetForm();
                validation.setSubmitting(false);
                validation.setStatus({success: true});
                toast.success('Link de redefinição de senha enviado com sucesso!');
                navigate('/login');
            });
        },
    });

    document.title = 'Redefinir senha | Ad Pulse';
    return (
        <ParticlesAuth>
            <div className="auth-page-content mt-lg-5">

                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                                    <Link to="/" className="d-inline-block auth-logo">
                                        <img src={logoLight} alt="" height="60"/>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">

                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Esqueceu sua senha?</h5>
                                        <p className="text-muted">Redefinir senha com Ad Pulse</p>

                                        <i className="ri-mail-send-line display-5 text-success mb-3"></i>

                                    </div>

                                    <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                                        Insira seu e-mail e as instruções serão enviadas para você!
                                    </Alert>
                                    <div className="p-2">
                                        <Form
                                            autoComplete={'on'}
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <div className="mb-4">
                                                <Label htmlFor={'email'} className="form-label">E-mail</Label>
                                                <Input
                                                    name="email"
                                                    id="email"
                                                    className="form-control"
                                                    type="email"
                                                    autoComplete={'email'}
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email}
                                                    invalid={
                                                        !!(validation.touched.email && validation.errors.email)
                                                    }
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback type="invalid">
                                                        <div>{validation.errors.email}</div>
                                                    </FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="text-center mt-4">
                                                <button className="btn btn-success w-100" type="submit">Enviar link de
                                                    redefinição
                                                </button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="mt-4 text-center">
                                <p className="mb-0">Espere, eu lembro da minha senha... <Link to="/login"
                                                                                              className="fw-semibold text-primary text-decoration-underline"> Clique
                                    aqui </Link></p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>
        </ParticlesAuth>
    );
};

ForgetPasswordPage.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
